import { createRef } from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';
import { Card, withUIDQueryResults } from 'govbr.frontend.policy/components';
import { BlockPagination } from 'govbr.frontend.policy/components';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import styles from './CardsBody.module.less';

const messages = defineMessages({
  noContent: {
    id: 'There are no contents to list.',
    defaultMessage: 'There are no contents to list.',
  },
});

export const CardsBodyBase = (props) => {
  const {
    data,
    isEditMode,
    listingItems,
    totalPages,
    currentPage,
    onPaginationChange,
    prevBatch,
    nextBatch,
    intl,
    hasLoaded,
  } = props;
  const {
    title,
    subtitle,
    buttonLink,
    buttonLabel,
    cardSize = 'md',
    columns = '4',
    align = 'center',
    backgroundColor = 'gray',
    hideDescription = false,
    hideIcons = false,
  } = data;

  const wrapClasses = cx('d-flex my-5 justify-content-center');

  const gridClasses = cx(
    'd-flex flex-wrap',
    `justify-content-${align}`,
    styles[`cols${columns}`],
  );

  if (listingItems.length === 0) {
    return isEditMode && hasLoaded ? (
      <div className="text-danger text-center">
        {intl.formatMessage(messages.noContent)}
      </div>
    ) : null;
  }

  const listingRef = createRef();

  return (
    <div ref={listingRef} className="mb-4">
      {title || subtitle ? (
        <div className="text-center">
          {title ? <h2>{title}</h2> : null}
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      ) : null}

      <div className={wrapClasses}>
        <div className={gridClasses}>
          {listingItems.map((item, index) =>
            item ? (
              <div className={styles.wrapper} key={`${item['@id']}-${index}`}>
                <div className={styles.cardInner}>
                  <Card
                    isEditMode={isEditMode}
                    item={item}
                    size={cardSize}
                    background={backgroundColor}
                    hideDescription={hideDescription}
                    hideIcons={hideIcons}
                    columns={columns}
                  />
                </div>
              </div>
            ) : null,
          )}
        </div>
      </div>

      {buttonLink &&
      buttonLink.length > 0 &&
      buttonLabel &&
      buttonLabel.length > 0 ? (
        <div className="text-center">
          <UniversalLink
            item={buttonLink[0]}
            className="br-button secondary small"
          >
            {buttonLabel}
          </UniversalLink>
        </div>
      ) : null}
      <BlockPagination
        totalPages={totalPages}
        currentPage={currentPage}
        isEditMode={isEditMode}
        listingRef={listingRef}
        onPaginationChange={onPaginationChange}
        prevBatch={prevBatch}
        nextBatch={nextBatch}
      />
    </div>
  );
};

const CardsBody = withUIDQueryResults(CardsBodyBase, 'cards', [
  'titulo_card',
  'descricao_card',
  'icone_card',
  'image_scales',
  'alt_card',
  'UID',
  'remoteUrl',
]);

CardsBody.propTypes = {
  // data: PropTypes.shape({
  //   size: PropTypes.string,
  //   spacing: PropTypes.string,
  // }),

  isEditMode: PropTypes.bool,
};

export default CardsBody;
